import { EVENT_NAMES } from 'services/analytics/eventNames';
import { trackEvent } from 'services/analytics/trackEvent';

type ssoClickActionsType = 'start' | 'success' | 'failure';
type providerType = 'microsoft' | 'google';

export const trackLoginWithSSO = ({
  clickAction = 'start',
  clickText,
  provider,
  sectionName,
  subSectionName,
}: {
  clickAction?: ssoClickActionsType;
  clickText?: string;
  provider: providerType;
  sectionName?: string;
  subSectionName?: string;
}) => {
  trackEvent(EVENT_NAMES.LOGIN_WITH_SSO, {
    click_action: clickAction,
    click_text: clickText,
    provider,
    section_name: sectionName,
    sub_section_name: subSectionName,
  });
};

export const trackRegisterWithSSO = ({
  clickAction = 'start',
  clickText,
  provider,
  sectionName,
  subSectionName,
}: {
  clickAction?: ssoClickActionsType;
  clickText?: string;
  provider: providerType;
  sectionName?: string;
  subSectionName?: string;
}) => {
  trackEvent(EVENT_NAMES.REGISTER_WITH_SSO, {
    click_action: clickAction,
    click_text: clickText,
    provider,
    section_name: sectionName,
    sub_section_name: subSectionName,
  });
};

export const trackLinkWithSSO = ({
  clickAction = 'start',
  clickText,
  provider,
  sectionName,
  subSectionName,
}: {
  clickAction?: ssoClickActionsType;
  clickText?: string;
  provider: providerType;
  sectionName?: string;
  subSectionName?: string;
}) => {
  trackEvent(EVENT_NAMES.LINK_ACCOUNT_WITH_SSO, {
    click_action: clickAction,
    click_text: clickText,
    provider,
    section_name: sectionName,
    sub_section_name: subSectionName,
  });
};
